import { render, staticRenderFns } from "./EmailVerificationForm.vue?vue&type=template&id=d471275a"
import script from "./EmailVerificationForm.vue?vue&type=script&lang=js"
export * from "./EmailVerificationForm.vue?vue&type=script&lang=js"
import style0 from "./EmailVerificationForm.vue?vue&type=style&index=0&id=d471275a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports